$('.services_mobile').each(function() {
  var $container = $(this);
  $container.find('.accordion summary').on('click', function() {
    var $currentAccordion = $(this).parent();
    $container.find('.accordion').not($currentAccordion).removeAttr('open');
  });
});

document.querySelectorAll('.faqs_details').forEach(container => {
  container.addEventListener('click', event => {
    if (event.target.tagName === 'SUMMARY') {
      const currentAccordion = event.target.parentElement;
      container.querySelectorAll('.accordion').forEach(accordion => {
        if (accordion !== currentAccordion) {
          accordion.removeAttribute('open');
        }
      });
    }
  });
});
